import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EditingMode } from '../../models/editingMode';
import { Role } from "../../models/role";
import { MenuService } from './menu.service';
import { Menu } from '../../../asistente-en-linea/models/Menu';
import { DeleteMenuDialogComponent } from '../menu/dialog/delete/delete-menu-dialog.component';
import { ImportMenuDialogComponent } from '../menu/dialog/import/import-menu-dialog.component';
import { AreaFuncionalGAFU } from '../../models/area-funcional-gafu';
import { AuthService } from '../../auth/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { Asistente } from 'src/app/asistente-en-linea/models/Asistente';
import { AsistenteTipo } from "src/app/config/config/models/asistente-tipo";
import { MatSort } from '@angular/material/sort';


@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  [x: string]: any;
  AsistenteTipo = AsistenteTipo;
  cargandoDatos: boolean;
  menus: Menu[];
  menusBackup: Menu[];
  filtroCodigo: string = '';
  filtroNombre: string = '';
  asistentes: Asistente[];
  asistentesBackup: Asistente[];
  areasFuncionalesGAFU: AreaFuncionalGAFU[];
  areasFuncionalesGAFUSeleccionada: AreaFuncionalGAFU;
  menuSeleccionado: Menu;
  faq: any;
  visiblePath: string;
  maxPathLength: number = 100;
  puedeCrearOEliminarMenu: boolean;
  mostrarError: boolean;
  eliminarMenuSeleccionado: boolean;
  habilitarBotones: boolean;
  mostrarCargaArchivo: boolean;
  habilitarBotonImportar: boolean;
  habilitarBotonEliminar: boolean;
  esAdministrador: boolean;
  selectedFile: any = null;
  formData: any = null;
  // Indica el modo de edicion ; si es OFF entonces el panel derecho queda sin informacion
  editingMode: EditingMode;
  displayedColumns = ['id', 'codigoAsistente', 'nombre', 'tipo', 'gafuAreaFuncional', 'fechaActualizacion', 'usuarioAutualizador'];
  // displayedColumns = ['id', 'tipo', 'codigoAsistente', 'descripcion', 'texto', 'gafuAreaFuncional', 'habilitado', 'fechaActualizacion', 'usuarioAutualizador'];
  //dataSource: any;
  dataSource!: MatTableDataSource<any>;
  selection: any;
  initialSelection: any;
  allowMultiSelect: boolean;
  tiposAsistentes: string[];
  tipoAsistenteFiltro: string = "";
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  
  constructor(private menuService: MenuService, private route: ActivatedRoute, private router: Router, private authService: AuthService, public dialog: MatDialog) {
    this.editingMode = EditingMode.Off;
    this.puedeCrearOEliminarMenu = false;
    this.eliminarMenuSeleccionado = false;
    this.habilitarBotones = false;
    this.mostrarCargaArchivo = false;
    this.habilitarBotonImportar = false;
    this.habilitarBotonEliminar = false;
    this.initialSelection = [];
    this.allowMultiSelect = false;
    this.esAdministrador = false;
    this.menusBackup = [];
    this.selection = new SelectionModel<Menu>(this.allowMultiSelect, this.initialSelection);
  }



  ngOnInit() {
    this.areasFuncionalesGAFU = [];
    this.dataSource = new MatTableDataSource([]);
    for (let role of this.authService.getUser().roles) {
      if (role == Role.Admin || role == Role.MenuAdministrator) {
        this.puedeCrearOEliminarMenu = true;
        this.esAdministrador = true;
        break;
      }
    }
    //this.puedeCrearOEliminarMenu = false;
    let areaFuncionalFiltroTodos = new AreaFuncionalGAFU("Acceso a todas las areas funcionales", "Todos", "Todos")
    this.areasFuncionalesGAFU.push(areaFuncionalFiltroTodos);
    this.areasFuncionalesGAFUSeleccionada = areaFuncionalFiltroTodos;
    
    this.loadAsistentes();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }

  seleccionarMenu(element) {
    this.selection.toggle(element);
    this.habilitarBotones = false;
    this.habilitarBotonEliminar = false;
    this.mostrarCargaArchivo = false;
    let esNuevoMenu = false;
    if (!this.menuSeleccionado) {
      esNuevoMenu = true;
      this.menuSeleccionado = element;
    } else if (element && this.menuSeleccionado) {
      if (element.id != this.menuSeleccionado.id) {
        this.menuSeleccionado = element;
        esNuevoMenu = true;
      } else {
        this.menuSeleccionado = undefined;
      }
    }

    if (esNuevoMenu) {
      if (this.menuSeleccionado && this.menuSeleccionado.id) {
        this.habilitarBotones = true;
        if (!this.menuSeleccionado.habilitado) {
          this.habilitarBotonEliminar = true;
        }
      }
    }
  }
  salirAdministrador() {
    this.menuService.salirAdministrador();
    this.router.navigate(["/login"]);
  }

  getFormattedDate(date) {
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, '0');
    let day = date.getDate().toString().padStart(2, '0');

    let hour = date.getHours().toString().padStart(2, '0');
    let minutes = date.getMinutes().toString().padStart(2, '0');
    let seconds = date.getSeconds().toString().padStart(2, '0');
    return day + '/' + month + '/' + year + " " + hour + ":" + minutes + ":" + seconds;
  }

  loadAsistentes() {
    this.asistentes = [];
    this.asistentesBackup = [];
    this.cargandoDatos = true;
   // debugger
    this.menuService.loadAsistentes().subscribe((data: any) => {
      if (data && (data.statusCode == 200 || data.statusCode == 0)) {
        if (data.content.length > 0) {
          for (let m of data.content) {
            let asistente = new Asistente(
              m.id,
              m.descripcion,
              m.nombre,
              this.getFormattedDate(new Date(m.fechaCreacion)),
              this.getFormattedDate(new Date(m.fechaActualizacion)),
              m.usuarioAutualizador,
              m.gafuAreaFuncional == '*' ? 'Sin Restricción' : m.gafuAreaFuncional,
              m.habilitado,
              m.formulario ? m.formulario : null,
              m.chatDTO ? m.chatDTO : null,
              m.codigoAsistente
            ).definirTipo();
            this.asistentes.push(asistente);
            this.asistentesBackup.push(asistente);

            //if(this.esAdministrador) {
            let descripcion = '';
            let yaExisteEnLista = false;

            for (let area of this.areasFuncionalesGAFU) {
              if (area.areaFuncional == asistente.gafuAreaFuncional) {
                yaExisteEnLista = true;
                break;
              }
            }

            if (!yaExisteEnLista) {
              this.areasFuncionalesGAFU.push(new AreaFuncionalGAFU(asistente.gafuAreaFuncional, asistente.gafuAreaFuncional, descripcion));
            }

            //}
          }
        }

        this.dataSource = new MatTableDataSource(this.asistentes);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.cargarDistintosTipos();
        this.cargandoDatos = false;
        this.mostrarCargaArchivo = false;
        this.eliminarMenuSeleccionado = false;
        this.habilitarBotonEliminar = false;
        this.habilitarBotones = false;
        this.menuSeleccionado = undefined;
        this.aplicarFiltros()
      }
      else {
        alert('Error: ' + (data.statusMessage || JSON.stringify(data)));

        this.cargandoDatos = false;
      }
    },
      error => {
        alert('Error: ' + JSON.stringify(error));
        this.cargandoDatos = false;
      })
  }

  /*
  loadMenus() {
    this.menus = [];
    this.menusBackup = [];
    this.cargandoDatos = true;
    this.menuService.loadMenus().subscribe((data: any) => {
      if (data && (data.statusCode == 200 || data.statusCode == 0)) {
        if (data.content.length > 0) {
          for (let m of data.content) {
            let menu = new Menu(
              m.id,
              m.descripcion,
              m.texto,
              this.getFormattedDate(new Date(m.fechaCreacion)),
              this.getFormattedDate(new Date(m.fechaActualizacion)),
              m.usuarioAutualizador,
              m.gafuAreaFuncional == '*' ? 'Sin Restricción' : m.gafuAreaFuncional,
              m.habilitado,
            ).definirTipo();
            this.menus.push(menu);
            this.menusBackup.push(menu);

            //if(this.esAdministrador) {
            let descripcion = '';
            let yaExisteEnLista = false;

            for (let area of this.areasFuncionalesGAFU) {
              if (area.areaFuncional == menu.gafuAreaFuncional) {
                yaExisteEnLista = true;
                break;
              }
            }

            if (!yaExisteEnLista) {
              /**for (let area of this.authService.getUser().areasFuncionales) {
                if(area.areaFuncional == menu.gafuAreaFuncional) {
                  descripcion = area.nombreAreaFuncional;
                  break;
                }
              }**//*
this.areasFuncionalesGAFU.push(new AreaFuncionalGAFU(menu.gafuAreaFuncional, menu.gafuAreaFuncional, descripcion));
}

//}
}
}

this.dataSource = new MatTableDataSource(this.menus);
this.dataSource.paginator = this.paginator;
this.cargarDistintosTipos();
this.cargandoDatos = false;
this.mostrarCargaArchivo = false;
this.eliminarMenuSeleccionado = false;
this.habilitarBotonEliminar = false;
this.habilitarBotones = false;
this.menuSeleccionado = undefined;
}
else {
alert(data.statusMessage);
this.cargandoDatos = false;
}
},
error => {
alert(error);
this.cargandoDatos = false;
})
}*/

  seleccionarParaEliminar() {
    this.mostrarCargaArchivo = false;
    this.eliminarMenuSeleccionado = false;
    if (this.menuSeleccionado && this.menuSeleccionado.id) {
      const dialogRef = this.dialog.open(DeleteMenuDialogComponent, {
        width: '400px',
        minHeight: '24vh',
        data: this.menuSeleccionado
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.loadAsistentes();
        }
      });
    }

  }


  editarConfiguracionesMenu() {
    this.mostrarCargaArchivo = false;
    if (this.menuSeleccionado && this.menuSeleccionado.id) {
      this.router.navigate(['/config/menu/'], { queryParams: { idMenu: this.menuSeleccionado.id, codigoAsistente: this.menuSeleccionado.codigoAsistente, nombreAsistente: this.menuSeleccionado.nombre  } });
    }
  }

  nuevoMenu() {
    this.router.navigate(['/config/nuevo/']);
  }
  editarDestinatariosMenu() {
    if (this.menuSeleccionado && this.menuSeleccionado.id) {
      this.router.navigate(['/config/menudestinatarios/'], { queryParams: { idMenu: this.menuSeleccionado.id } });
    }
  }
  editarDatosBasicosMenu() {
    this.mostrarCargaArchivo = false;
    //debugger
    if (this.menuSeleccionado && this.menuSeleccionado.id) {
      let asistenteId = this.menuSeleccionado.id;
      if (this.menuSeleccionado.tipo == 'Chat') {
        this.router.navigate(['/config/asistentechat/'], { queryParams: { idAsistente: asistenteId } });
      } else if (this.menuSeleccionado.tipo == 'Formulario') {
        this.router.navigate(['/config/asistenteformulario/'], { queryParams: { idAsistente: asistenteId } });
      } else {
        this.router.navigate(['/config/asistentemenu/'], { queryParams: { idMenu: this.menuSeleccionado.id } });
      }
    }
  }

  editarValidacionesMenu() {
    this.mostrarCargaArchivo = false;
    if (this.menuSeleccionado && this.menuSeleccionado.id) {
      this.router.navigate(['/config/menuvalidaciones/'], { queryParams: { idAsistente: this.menuSeleccionado.id } });
    }
  }

  cancelDeleteOperation() {
    this.mostrarCargaArchivo = false;
    this.eliminarMenuSeleccionado = false;
  }
  deleteMenu() {
    this.mostrarCargaArchivo = false;
    if (this.menuSeleccionado && this.menuSeleccionado.id) {
      this.menuService.deleteMenu(this.menuSeleccionado.id, this.authService.getUser().username).subscribe((data: any) => {
        if (data && (data.statusCode == 200 || data.statusCode == 0)) {
          this.eliminarMenuSeleccionado = false;
          this.menuSeleccionado = null;
          this.habilitarBotones = false;
          this.loadAsistentes();
        } else {
          alert(data.statusMessage);
          this.cargandoDatos = false;
        }
      },
        error => {
          alert(error);
          this.cargandoDatos = false;
          this.eliminarMenuSeleccionado = false;
        })
    }
  }

  exportarMenu() {
    this.mostrarCargaArchivo = false;
    this.cargandoDatos = true;
    if (this.menuSeleccionado && this.menuSeleccionado.id) {
      this.menuService.exportarMenu(this.menuSeleccionado.id).subscribe(blob => {
        const a = document.createElement('a');
        let blobtTMP = new Blob([blob], { type: 'application/json;charset=utf-8;' });
        const objectUrl = URL.createObjectURL(blobtTMP);
        a.href = objectUrl;
        a.download = this.menuSeleccionado.descripcion + ".json";
        a.click();
        URL.revokeObjectURL(objectUrl);
        this.cargandoDatos = false;
      },
        error => {
          alert(error);
          this.cargandoDatos = false;
          this.eliminarMenuSeleccionado = false;
        });
    }
  }
  cargarArchivo() {
    const dialogRef = this.dialog.open(ImportMenuDialogComponent, {
      width: '600px',
      minHeight:'300px',
      //min-height: '400px',
      height: 'auto',
      data: this.menuSeleccionado
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadAsistentes();
    });
  }
  cancelarCargarArchivo() {
    this.selectedFile = null;
    this.mostrarCargaArchivo = false;
    this.eliminarMenuSeleccionado = false;
  }

  async importarMenu() {
    this.cargandoDatos = true;
    this.menuService.importarMenu(this.formData, this.menuSeleccionado.id, this.authService.getUser().username).subscribe((data: any) => {
      if (data && (data.statusCode == 200 || data.statusCode == 0)) {
        //console.log(data.mensaje);
        this.eliminarMenuSeleccionado = false;
        this.menuSeleccionado = null;
        this.habilitarBotones = false;
        this.selectedFile = null;
        this.mostrarCargaArchivo = false;
        this.eliminarMenuSeleccionado = false;
        this.cargandoDatos = false;
        if (data.mensaje) {
          alert("El menú se actualizó correctamente. Verifique la advertencia siguiente: " + data.mensaje);
        }

        this.loadAsistentes();
      } else {
        alert(data.statusMessage);
        this.cargandoDatos = false;
      }
    },
      error => {
        alert(error);
        this.cargandoDatos = false;
        this.eliminarMenuSeleccionado = false;
      })
  }

  cargarDistintosTipos() {
    this.tiposAsistentes = [...new Set(this.asistentes.map(d => d.tipo))];
  }

  aplicarFiltros() {
    let asistentesFiltrados = this.asistentesBackup;
    //Mantengo el filtro de área funcional
    if (this.areasFuncionalesGAFUSeleccionada && this.areasFuncionalesGAFUSeleccionada.areaFuncional != 'Todos') {
      asistentesFiltrados = asistentesFiltrados.filter(a => a.gafuAreaFuncional == this.areasFuncionalesGAFUSeleccionada.areaFuncional);
    }

    //Aplico filtro por tipo de asistente
    if (this.tipoAsistenteFiltro != "") {
      asistentesFiltrados = asistentesFiltrados.filter(m => m.tipo == this.tipoAsistenteFiltro);
    }

    if(this.filtroCodigo && this.filtroCodigo !="" && this.filtroCodigo.trim().length > 0) {
      asistentesFiltrados = asistentesFiltrados.filter(m => m.codigoAsistente?.toUpperCase().includes(this.filtroCodigo.trim().toUpperCase()));
    }

    if(this.filtroNombre && this.filtroNombre !="" && this.filtroNombre.trim().length > 0) {
      asistentesFiltrados = asistentesFiltrados.filter(m => m.nombre?.toUpperCase().includes( this.filtroNombre.trim().toUpperCase()));
    }

    this.asistentes = asistentesFiltrados;
    this.dataSource = new MatTableDataSource(this.asistentes);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  recargarAsistentes() {
    this.loadAsistentes();
  }
}